<template>
	<v-container fluid class="pt-0">
		<v-row>
			<v-col cols="12" xl="12" lg="12" md="12">
				<v-tabs>
					<v-tab>{{ $t('tabs.basicInfo') }}</v-tab>
					<v-tab v-if="$route.params.id != 0 && !inEditMode">{{ $t('tabs.certificates') }}</v-tab>
					<v-tab v-if="$route.params.id != 0 && !inEditMode">{{ $t('tabs.courses') }}</v-tab>
					<v-tab v-if="$route.params.id != 0 && !inEditMode">{{ $t('tabs.documents') }}</v-tab>
					<v-tab v-if="$route.params.id != 0 && !inEditMode && candidate.loyalty_consent">{{
						$t('tabs.loyalty')
					}}</v-tab>
					<v-tab v-if="$route.params.id != 0 && !inEditMode">{{ $t('tabs.paymentContracts') }}</v-tab>
					<v-tab-item>
						<v-card flat outlined>
							<v-card-text>
								<v-row>
									<v-flex lg6 xs12 class="pt-0">
										<v-card-title class="pa-2">
											{{ $t('titles.candidateInformations') }}
										</v-card-title>
									</v-flex>
									<v-col class="d-flex justify-end">
										<v-btn
											v-if="
												!inEditMode &&
												$route.params.id != 0 &&
												$myStore.state.user.user_role_id == 1
											"
											class="mt-2 ml-2 mr-2"
											color="warning"
											@click="gdprDeleteClick()"
										>
											<v-icon small>fa-trash</v-icon>&nbsp;{{ $t('buttons.gdprDelete') }}
										</v-btn>
										<v-btn
											v-if="inEditMode"
											class="mt-2 ml-2 mr-2"
											color="primary"
											@click="saveClick(null)"
										>
											<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
										</v-btn>
										<v-btn
											v-if="!inEditMode"
											class="mt-2 ml-2 mr-2"
											color="primary"
											@click="editClick()"
										>
											<v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
										</v-btn>
										<v-btn class="mt-2 ml-2 mr-2" color="basicButton" @click="backClick">
											<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
										</v-btn>
									</v-col>
								</v-row>
								<v-row wrap>
									<v-flex lg6 xs12 sm12 class="pt-0">
										<v-col cols="12" v-if="inEditMode && $route.params.id != 0">
											<InputField
												:disabled="true"
												v-model="candidate.id"
												:label="'* ' + $t('fields.id')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="candidate.first_name"
												:errorBorder="!candidateValidation.first_name"
												:label="'* ' + $t('fields.firstName')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="candidate.last_name"
												:errorBorder="!candidateValidation.last_name"
												:label="'* ' + $t('fields.lastName')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="candidate.oib"
												:errorBorder="!candidateValidation.oib"
												:label="'* ' + $t('fields.oib')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="candidate.id_card_or_passport_number"
												:errorBorder="!candidateValidation.id_card_or_passport_number"
												:label="$t('fields.idCardOrPassportNumber')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<DatePicker
												:readonly="!inEditMode"
												v-model="candidate.date_of_birth"
												:errorBorder="!candidateValidation.date_of_birth"
												:date-label="'* ' + $t('fields.dateOfBirth')"
											></DatePicker>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="candidate.place_of_birth"
												:errorBorder="!candidateValidation.place_of_birth"
												:label="'* ' + $t('fields.placeOfBirth')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												v-model="candidate.country_of_birth_id"
												:ajax="true"
												:clearable="true"
												:data="'countries'"
												:errorBorder="!candidateValidation.country_of_birth_id"
												:label="'* ' + $t('fields.countryOfBirth')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="candidate.address"
												:errorBorder="!candidateValidation.address"
												:label="$t('fields.address')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="candidate.postal_code"
												:errorBorder="!candidateValidation.postal_code"
												:label="$t('fields.postalCode')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="candidate.city"
												:errorBorder="!candidateValidation.city"
												:label="'* ' + $t('fields.city')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												v-model="candidate.county_id"
												:ajax="true"
												:clearable="true"
												:data="'counties'"
												:errorBorder="!candidateValidation.county_id"
												:label="$t('fields.county')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												v-model="candidate.country_id"
												:ajax="true"
												:clearable="true"
												:data="'countries'"
												:errorBorder="!candidateValidation.country_id"
												:label="'* ' + $t('fields.country')"
											></Dropdown>
										</v-col>
									</v-flex>
									<v-flex lg6 xs12 sm12 class="pt-0">
										<v-col cols="12" v-if="candidate.loyalty_consent == true">
											<InputField
												:readonly="true"
												:disabled="true"
												v-model="candidate.loyalty_points"
												:label="$t('fields.loyaltyPoints')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="candidate.phone"
												:errorBorder="!candidateValidation.phone"
												:label="'* ' + $t('fields.phone')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												v-model="candidate.email"
												:errorBorder="!candidateValidation.email"
												:label="'* ' + $t('fields.email')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<Dropdown2
												:readonly="!inEditMode"
												v-model="candidate.partner_id"
												:ajax="true"
												:clearable="true"
												:data="'partners-buyers'"
												:errorBorder="!candidateValidation.partner_id"
												:label="$t('fields.company')"
											></Dropdown2>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												v-model="candidate.rank_id"
												:ajax="true"
												:clearable="true"
												:data="'ranks'"
												:errorBorder="!candidateValidation.rank_id"
												:label="$t('fields.rank')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<TextArea
												:readonly="!inEditMode"
												v-model="candidate.remark"
												:errorBorder="!candidateValidation.remark"
												:label="$t('fields.remark')"
												rows="3"
											></TextArea>
										</v-col>
										<v-col cols="12">
											<CheckBox
												:readonly="!inEditMode"
												v-model="candidate.loyalty_consent"
												:label="$t('fields.loyaltyConsent')"
											></CheckBox>
										</v-col>
										<v-col
											cols="12"
											v-if="
												candidate.loyalty_consent == true &&
												(candidate.loyalty_file.upload_id != null || inEditMode)
											"
										>
											<Upload
												:readonly="!inEditMode"
												:label="$t('fields.loyaltyConsent')"
												v-model="candidate.loyalty_file"
												:errorBorder="!candidateValidation.loyalty_file"
											></Upload>
										</v-col>
										<v-col
											cols="12"
											v-if="candidate.loyalty_consent == true && $route.params.id != 0"
										>
											<InputField
												:disabled="true"
												v-model="candidate.loyalty_card"
												:errorBorder="!candidateValidation.loyalty_card"
												:label="$t('fields.loyaltyCard')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<CheckBox
												:readonly="!inEditMode"
												v-model="candidate.gdpr_consent"
												:label="$t('fields.gdprConsent')"
											></CheckBox>
										</v-col>
										<v-col
											cols="12"
											v-if="
												candidate.gdpr_consent == true &&
												(candidate.gdpr_file.upload_id != null || inEditMode)
											"
										>
											<Upload
												:readonly="!inEditMode"
												:label="$t('fields.gdprConsent')"
												v-model="candidate.gdpr_file"
												:errorBorder="!candidateValidation.gdpr_file"
											></Upload>
										</v-col>
										<v-col cols="12">
											<CheckBox
												:readonly="!inEditMode"
												v-model="candidate.active"
												:label="$t('fields.active')"
											></CheckBox>
										</v-col>
										<v-col cols="12">
											<CheckBox
												:readonly="!inEditMode"
												v-model="candidate.notifications"
												:label="$t('fields.notifications')"
											></CheckBox>
										</v-col>
									</v-flex>
								</v-row>
							</v-card-text>
						</v-card>
					</v-tab-item>
					<v-tab-item><CandidateCertificates></CandidateCertificates></v-tab-item>
					<v-tab-item v-if="!inEditMode"
						><CandidateCourses :candidateId="candidate.id"></CandidateCourses>
					</v-tab-item>
					<v-tab-item v-if="!inEditMode"> <CandidateDocuments></CandidateDocuments></v-tab-item>
					<v-tab-item v-if="!inEditMode && candidate.loyalty_consent">
						<LoyaltyTransactions :candidateLoyaltyPoints="candidate.loyalty_points"></LoyaltyTransactions>
					</v-tab-item>
					<v-tab-item v-if="!inEditMode"> <CandidatePaymentContracts></CandidatePaymentContracts></v-tab-item>
				</v-tabs>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from '../../trinkets/InputField';
import CheckBox from '../../trinkets/CheckBox';
import Candidate from '../../../models/Candidate';
import Dropdown from '../../trinkets/Dropdown';
import Dropdown2 from '../../trinkets/Dropdown2';
import DatePicker from '../../trinkets/DatePicker';
import TextArea from '../../trinkets/TextArea';
import Upload from '../../trinkets/Upload';
import CandidateDocuments from './CandidateDocuments';
import CandidateCourses from './CandidateCourses';
import CandidateCertificates from './CandidateCertificates';
import LoyaltyTransactions from './LoyaltyTransactions';
import CandidatePaymentContracts from './CandidatePaymentContracts';

export default {
	name: 'Candidate',
	components: {
		CheckBox,
		InputField,
		DatePicker,
		Dropdown,
		Dropdown2,
		TextArea,
		CandidateDocuments,
		Upload,
		CandidateCourses,
		CandidateCertificates,
		LoyaltyTransactions,
		CandidatePaymentContracts,
	},
	data: function () {
		return {
			candidate: new Candidate({ id: this.$route.params.id }),
			candidateValidation: new Candidate({}, true),
			initialLoad: false,
			inEditMode: false,
			lockKey: 'candidate',
			lockTimer: null,
			cardExist: false,
			oldCardExist: false,
		};
	},
	watch: {
		'candidate.loyalty_consent': function (newVal) {
			if (this.$route.params.id != 0) {
				if (this.initialLoad && newVal && (this.oldCardExist || !this.cardExist)) {
					this.candidate.loyalty_card = 'L' + this.candidate.id;
				}
			}
		},
	},
	methods: {
		editClick() {
			let vm = this;
			this.$setLock(this, this.lockKey + '|' + this.candidate.id, (data) => {
				if (data.success) {
					vm.inEditMode = true;
					vm.lockTimer = setInterval(() => {
						vm.$setLock(vm, vm.lockKey + '|' + vm.candidate.id);
					}, 10000);
				} else {
					vm.$alert(
						vm
							.$t('alerts.recordLocked')
							.split('%name%')
							.join(data.locked_by.first_name + ' ' + data.locked_by.last_name)
					);
				}
			});
		},
		backClick() {
			this.$router.go(-1);
		},
		gdprDeleteClick() {
			let vm = this;
			this.$verify(this.$t('alerts.gdprCandidateDeletionQuestion'), (result) => {
				if (result) {
					vm.$APICall(
						'delete',
						'candidates/' + this.candidate.id + '/delete',
						{ candidate_id: this.candidate.id },
						(data, success) => {
							if (success) {
								vm.$notify(vm.$t('alerts.basicDelete'));
								vm.backClick();
							} else {
								vm.$alert(vm.$t('alerts.basicError'));
							}
						}
					);
				}
			});
		},
		saveClick(after = null) {
			let success = true;
			let errorMessages = '';

			if (this.candidate.first_name == null || this.candidate.first_name == '') {
				success = false;
				this.candidateValidation.first_name = false;
			} else {
				if (this.candidate.first_name.length > 50) {
					this.candidateValidation.first_name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.first_name'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.candidateValidation.first_name = true;
				}
			}

			if (this.candidate.last_name == null || this.candidate.last_name == '') {
				success = false;
				this.candidateValidation.last_name = false;
			} else {
				if (this.candidate.last_name.length > 50) {
					this.candidateValidation.last_name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.last_name'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.candidateValidation.last_name = true;
				}
			}

			if (this.candidate.oib == null || this.candidate.oib == '') {
				success = false;
				this.candidateValidation.oib = false;
			} else {
				if (this.candidate.oib.length > 20) {
					this.candidateValidation.oib = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.oib'))
							.replace('%length%', '20') + '<br />';
				} else {
					this.candidateValidation.oib = true;
				}
			}

			if (this.candidate.id_card_or_passport_number != null && this.candidate.id_card_or_passport_number !== '') {
				if (
					this.candidate.id_card_or_passport_number != '' &&
					this.candidate.id_card_or_passport_number.length > 15
				) {
					this.candidateValidation.id_card_or_passport_number = false;
					success = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.idCardOrPassportNumber'))
							.replace('%length%', '20') + '<br />';
				} else {
					this.candidateValidation.id_card_or_passport_number = true;
				}
			}

			if (!this.candidate.date_of_birth) {
				success = false;
				this.candidateValidation.date_of_birth = false;
			} else {
				this.candidateValidation.date_of_birth = true;
			}

			if (this.candidate.place_of_birth == null || this.candidate.place_of_birth == '') {
				success = false;
				this.candidateValidation.place_of_birth = false;
			} else {
				if (this.candidate.place_of_birth.length > 50) {
					this.candidateValidation.place_of_birth = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.place_of_birth'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.candidateValidation.place_of_birth = true;
				}
			}

			if (!this.candidate.country_of_birth_id) {
				success = false;
				this.candidateValidation.country_of_birth_id = false;
			} else {
				this.candidateValidation.country_of_birth_id = true;
			}

			if (this.candidate.address != null && this.candidate.address.length > 100) {
				this.candidateValidation.address = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.address'))
						.replace('%length%', '100') + '<br />';
			} else {
				this.candidateValidation.address = true;
			}

			if (this.candidate.postal_code != null && this.candidate.postal_code.length > 20) {
				this.candidateValidation.postal_code = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.postalCode'))
						.replace('%length%', '20') + '<br />';
			} else {
				this.candidateValidation.postal_code = true;
			}

			if (this.candidate.city == null || this.candidate.city == '') {
				success = false;
				this.candidateValidation.city = false;
			} else {
				if (this.candidate.city.length > 50) {
					this.candidateValidation.city = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.city'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.candidateValidation.city = true;
				}
			}

			if (!this.candidate.country_id) {
				success = false;
				this.candidateValidation.country_id = false;
			} else {
				this.candidateValidation.country_id = true;
			}

			if (this.candidate.phone == null || this.candidate.phone == '') {
				success = false;
				this.candidateValidation.phone = false;
			} else {
				if (this.candidate.phone.length > 20) {
					this.candidateValidation.phone = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.phone'))
							.replace('%length%', '20') + '<br />';
				} else {
					this.candidateValidation.phone = true;
				}
			}

			if (this.candidate.email == null || this.candidate.email == '') {
				success = false;
				this.candidateValidation.email = false;
			} else {
				if (!this.$checkEmail(this.candidate.email)) {
					this.candidateValidation.email = false;
					errorMessages += this.$t('alerts.formatError').split('%value%').join('E-mail') + '<br />';
				} else {
					this.candidateValidation.email = true;
				}
			}

			if (this.candidate.remark != null && this.candidate.remark.length > 500) {
				this.candidateValidation.remark = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.remark'))
						.replace('%length%', '500') + '<br />';
			} else {
				this.candidateValidation.remark = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.candidate.id != 0) {
					action = 'put';
					addition = '/' + vm.candidate.id;
				}
				if (!this.candidate.loyalty_consent) {
					this.candidate.loyalty_file.upload_id = null;
					this.candidate.loyalty_card = null;
				}
				if (!this.candidate.gdpr_consent) {
					this.candidate.gdpr_file.upload_id = null;
				}
				this.$APICall(action, 'candidates' + addition, this.candidate, (data, success) => {
					if (success) {
						if (data == 409) {
							vm.$alert(vm.$t('alerts.oibExists'));
							vm.candidateValidation.oib = false;
							return;
						}
						vm.inEditMode = false;
						if (vm.candidate.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						if (after !== null) {
							after();
						} else {
							vm.backClick();
						}
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
	},
	beforeRouteLeave(to, from, next) {
		let vm = this;
		if (this.inEditMode) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				if (result) {
					if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
					vm.$removeLock(vm, vm.lockKey + '|' + vm.candidate.id);
					next(true);
				} else {
					next(false);
				}
			});
		} else {
			if (this.lockTimer !== null) clearInterval(this.lockTimer);
			vm.$removeLock(vm, vm.lockKey + '|' + vm.candidate.id);
			next(true);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		let vm = this;
		if (this.candidate.id != 0) {
			this.$APICall('get', 'candidates/' + this.candidate.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.candidate = usableData;
					if (
						vm.candidate.loyalty_consent &&
						vm.candidate.loyalty_card &&
						vm.candidate.loyalty_card.charAt(0) !== 'L'
					) {
						vm.oldCardExist = true;
					}

					if (vm.candidate.loyalty_consent && vm.candidate.loyalty_card) {
						vm.cardExist = true;
					} else {
						vm.cardExist = false;
					}

					vm.$myStore.commit('setBreadcrumbs', [
						{
							text: vm.$t('modules.candidates'),
							href: '/#/candidates',
							disabled: false,
						},
						{
							text: vm.candidate.first_name + ' ' + vm.candidate.last_name + ' (' + vm.candidate.id + ')',
							href: '/#/candidates/' + vm.candidate.id,
							disabled: true,
						},
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{
					text: this.$t('modules.candidates'),
					href: '/#/candidates',
					disabled: false,
				},
				{
					text: this.$t('modules.newCandidate'),
					href: '/#/candidates/0',
					disabled: true,
				},
			]);
			this.inEditMode = true;
			this.initialLoad = true;
		}
	},
};
</script>

<style scoped></style>
